import type {ReactNode} from 'react';
import {cn} from '../lib/cn';
import {RadioGroupItem} from '../radio-group';
import {Radio} from './Radio';
import type {RadioProps} from './types';

type RadioWithBorderData = Pick<RadioProps, 'size'> & {
  subLabel?: string;
  description?: string;
  rightContent?: ReactNode;
};

export function RadioWithBorder({size, ...props}: RadioProps) {
  return (
    <Radio
      {...props}
      renderOption={({option, isSelected}) => {
        const data = option.data as RadioWithBorderData | undefined;

        return (
          <div
            className={cn(
              'flex w-full items-start gap-3 rounded-lg border p-4 transition-all duration-200',
              isSelected &&
                'border-[var(--chekin-color-brand-blue)] bg-[var(--chekin-color-surface-autocomplete)]',
            )}
          >
            <RadioGroupItem
              className="mt-1"
              value={option.value}
              id={`option-${option.value}`}
              disabled={option.disabled}
              size={size}
            />
            <div className="flex min-w-0 flex-1 items-start justify-between gap-3">
              <div className="min-w-0 space-y-1 leading-6">
                <p className="flex items-center gap-3 font-semibold">
                  {option.label}
                  {data?.subLabel && (
                    <span className="rounded bg-[color-mix(in_srgb,var(--chekin-color-brand-blue)_10%,transparent)] px-2 py-1 text-sm font-semibold leading-4 text-[var(--chekin-color-brand-blue)]">
                      {data.subLabel}
                    </span>
                  )}
                </p>
                {data?.description && (
                  <p className="text-sm font-medium text-[var(--chekin-color-gray-1)]">
                    {data.description}
                  </p>
                )}
              </div>
              {data?.rightContent && <div className="shrink-0">{data.rightContent}</div>}
            </div>
          </div>
        );
      }}
    />
  );
}
